import { TimeseriesChartBandProps } from '../../types/timeseries-band.js';

export const Band = (props: TimeseriesChartBandProps) => null;

Band['displayName'] = 'TimeseriesChart.Band';
